<template>
	<v-sheet class="full-height">
		<v-app-bar rounded color="blue">系统配置</v-app-bar>
		<v-card>
			<v-card-text>
				<v-row>
					<v-col cols="3">
						<v-card >
							<v-card-title><span class="red--text text-h6">老师奖金计算方式设置</span></v-card-title>
							<v-card-text class="ml-4 mt-n4">
								<v-radio-group v-model="config.teacherBonusType" >
									<v-radio value="1" label="1.按核销课时数计算，核销1课时奖励X元" color="red"></v-radio>
									<v-radio value="2" label="2.按到课学生数计算，到课1人奖励X元" color="red"></v-radio>
									<v-radio value="3" label="3.按上课次数计算,每次上课奖励X元" color="red"></v-radio>
									<v-radio value="4" label="4.不需要系统计算" color="red"></v-radio>
								</v-radio-group>
							</v-card-text>
							<v-card-text v-if="config.teacherBonusType !=='4'" class="d-flex ml-4 mt-n7">
								<v-text-field v-model="config.teacherBonusFee" type="number" label="奖励金额" dense outlined style="width:100px"></v-text-field>
								<span class="ml-2 mt-3">元</span>
								<v-spacer></v-spacer>
								
							</v-card-text>
						</v-card>
						
						
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<!-- <v-spacer></v-spacer> -->
				<v-btn color="info" class="ma-4" @click="submitConfig">提交修改</v-btn>
			</v-card-actions>
		</v-card>
	</v-sheet>
</template>

<script>
	export default {
		name:"config",
		data(){
			return {
				config:{
					id:"",
					teacherBonusType:"",// 提成方式
					teacherBonusFee:"",//奖金金额
				},
			}
		},
		created(){
			this.getConfig();
		},
		methods:{
			submitConfig(){
				//提交修改配置
				if(!this.config.teacherBonusType){
					this.$noty.error("请选择教师奖金计算方式");
					return
				}
				if(this.config.teacherBonusType !=='4'){
					if(!this.config.teacherBonusFee){
						this.$noty.error("请输入奖励金额");
						return
					}
				}
				// api
				const that = this;
				let url = `/sys/config/update`;
				let postData = this.config;
		
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("提交成功");
							that.getConfig();
				
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				});
			},
			getConfig(){
				// 获取配置
				const that = this;
	
				let url = `/sys/config`;
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						const resData = response.data["data"];
						that.config.id = resData["id"];
						that.config.teacherBonusType = resData["teacherBonusType"];
						that.config.teacherBonusFee = resData["teacherBonusFee"];
						
						return
					}
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
		
	};
</script>

<style>
</style>
